import { render, staticRenderFns } from "./periodDescriptionInput.vue?vue&type=template&id=f73608b6&"
import script from "./periodDescriptionInput.vue?vue&type=script&lang=js&"
export * from "./periodDescriptionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports